import React from 'react'
import { TransProps } from '@lingui/react'
import { HeaderDashboard } from './HeaderDashboard'
import { typeDProductInfoActions } from 'components/containers/dashboard/dataProducts/actions';
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary';


// Type
export type typeDashboardContentPage = {
    headerTitle: React.ReactElement<TransProps>
    setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>
    actions?: React.ReactElement<typeDProductInfoActions>
    goBack?: boolean
}


// Component
export const DashboardContentPage: React.FC<typeDashboardContentPage> = ({
                                                                             headerTitle,
                                                                             setSidebarOpen,
                                                                             actions,
                                                                             children,
                                                                             goBack
                                                                         }) => {

    return (
        <div className="relative flex flex-col gap-4 data-panel">
            <ErrorBoundary>
                <div className="flex gap-7 flex-col md:flex-row md:justify-between">

                    <HeaderDashboard
                        headerTitle={ headerTitle }
                        setSidebarOpen={ setSidebarOpen }
                        goBack={ goBack }
                    />

                    <div className="flex flex-wrap gap-2 justify-center">
                        { actions }
                    </div>

                </div>

                { children }
            </ErrorBoundary>
        </div>
    )
}
